<template>
  <div class="profile-section">
    <h1 class="text-3xl font-bold mb-2" :style="{ color: themeColor }">
      {{ section.data.fullName || 'Your Name' }}
    </h1>
    <p class="text-lg text-gray-600 mb-4">{{ section.data.title || 'Your Title' }}</p>
    <div class="flex flex-wrap gap-4 text-sm text-gray-700">
      <span v-if="section.data.email">{{ section.data.email }}</span>
      <span v-if="section.data.phone">{{ section.data.phone }}</span>
      <span v-if="section.data.location">{{ section.data.location }}</span>
    </div>
    <p v-if="section.data.summary" class="mt-4 text-gray-700">{{ section.data.summary }}</p>
  </div>
</template>

<script>
export default {
  props: {
    section: {
      type: Object,
      required: true
    },
    themeColor: {
      type: String,
      default: '#17803d'
    }
  }
}
</script>

